<template>
  <div>
    <div
      v-if="market && showHeading"
      class="caption pr-0 py-0 pl-0 v-expansion-panel-header"
    >
      <simple-bar
        hide-controls
        :title="market.name"
        :bookmaker="market.name === 'BOOKMAKER'"
        :delay-time="market.name === 'BOOKMAKER' ? 0 : market.betDelay"
        :side-text="['Back', 'Lay']"
        :market-id="marketId"
        :market="market"
      ></simple-bar>
    </div>
    <template v-for="(runner, k) in markets">
      <v-card
        :key="`key-${k}`"
        class="d-flex align-center item-odds"
        dense
        flat
        tile
        height="45"
      >
        <v-btn
          v-if="!twoOdds && runner.name"
          text
          tile
          color="white"
          class="text-capitalize text-left justify-start caption font-weight-bold flex-grow-1 flex-shrink-1"
          v-bind="$attrs"
          :to="
            event &&
            event.eventTypeId &&
            event.competition &&
            event.competition.id &&
            event.event &&
            event.event.id &&
            `/sportsbook/${event.eventTypeId}/${event.competition.id}/${event.event.id}`
          "
          v-on="$listeners"
        >
          <span class="black--text manage-overflow-two">
            {{ runner.name }}

            <span v-if="$auth.loggedIn">
              <br />
              <span
                v-if="books && books[`${market.id}-${runner.id}`]"
                :class="{
                  'green--text ': getBooks(books, runner.id) > 0,
                  'red--text': getBooks(books, runner.id) < 0,
                  'black--text ': getBooks(books, runner.id) == 0
                }"
              >
                {{
                  (getBooks(books, runner.id) / getMyRate()) | currencyFormat(2)
                }}
              </span>
              <span
                v-if="newBooks && newBooks[`${market.id}-${runner.id}`]"
                :class="{
                  'green--text ':
                    (getBooks(books, runner.id)
                      ? getBooks(books, runner.id) +
                        getBooks(newBooks, runner.id)
                      : getBooks(newBooks, runner.id)) > 0,
                  'red--text':
                    (getBooks(books, runner.id)
                      ? getBooks(books, runner.id) +
                        getBooks(newBooks, runner.id)
                      : getBooks(newBooks, runner.id)) < 0,
                  'black--text ':
                    (getBooks(books, runner.id)
                      ? getBooks(books, runner.id) +
                        getBooks(newBooks, runner.id)
                      : getBooks(newBooks, runner.id)) == 0
                }"
              >
                <v-icon
                  v-if="
                    getBooks(books, runner.id) && getBooks(newBooks, runner.id)
                  "
                  size="12"
                  >mdi-chevron-right
                </v-icon>
                {{
                  (getBooks(books, runner.id)
                    ? getBooks(books, runner.id) / getMyRate() +
                      getBooks(newBooks, runner.id)
                    : getBooks(newBooks, runner.id)) | currencyFormat(2)
                }}
              </span>
            </span>
          </span>
        </v-btn>
        <odds-disabled
          v-if="suspendedCheck(market)"
          :text="suspendedCheck(market)"
          :issideright="
            market.bookMakerCustom || market.name === 'fancy'
              ? 'rightsidebutton'
              : ''
          "
          :fortwoodds="twoOdds"
          v-bind="$attrs"
          v-on="$listeners"
        ></odds-disabled>

        <template
          v-for="(i, key) in xsOnlyOdds(
            $breakpoint.xsOnly,
            'back',
            market,
            runner
          )"
        >
          <btn-odds
            v-if="
              ($auth.loggedIn && ((i === 0 && twoOdds) || !twoOdds)) ||
              !$auth.loggedIn
            "
            :key="'back' + key"
            type="back"
            :market-id="market.event.id"
            :class="{
              'opacity-0':
                (i !== 0 && twoOdds) ||
                (i !== 0 &&
                  (market.bookmakerMultiOdds === false ||
                    socketData.bookmakerMultiOdds === false) &&
                  bookmaker),
              'flex-grow-1': twoOdds
            }"
            :disabled="
              (i !== 0 && twoOdds) || !check(runner, 'back', i, market)
            "
            v-bind="$attrs"
            v-on="$listeners"
            @betData="
              $store.commit('placeBet/openPopover', {
                event,
                market: marketList?.[groupIndex(k)] || market,
                runner,
                allRunners: markets,
                oddsIndex: i,
                odds: {
                  price: getObjValue(runner.back, i, ['price'], '-'),
                  index: i,
                  type: 'back'
                },
                type: 'back',
                bettingType:
                  market.bookMakerCustom && market.isJodiMarket
                    ? 'multiHorse'
                    : market.bookMakerCustom && !market.isJodiMarket
                    ? 'bookmaker'
                    : 'default'
              })
            "
          >
            <span
              v-if="market && check(runner, 'back', i, market)"
              class="d-block text-center"
            >
              {{
                (market.id.includes('_SB')
                  ? (getObjValue(runner.back, i, ['price'], '-', 'back') - 1) *
                    100
                  : getObjValue(runner.back, i, ['price'], '-', 'back'))
                  | currencyFormat(2)
              }}
              <multiplyer
                v-if="
                  check(runner, 'back', i, market) &&
                  getObjValue(runner.back, i, ['size'], '-', 'back') &&
                  !market.id.includes('_SB')
                "
                :rates="getObjValue(runner.back, i, ['size'], '-', 'back')"
                :multiplyer="multiplyer"
              ></multiplyer>
            </span>

            <span v-else class="d-block text-center">-</span>
          </btn-odds>
        </template>

        <template v-for="(i, key) in xsOnlyOdds($breakpoint.xsOnly)">
          <btn-odds
            v-if="
              ($auth.loggedIn && ((i === 0 && twoOdds) || !twoOdds)) ||
              !$auth.loggedIn
            "
            :key="'lay' + key"
            type="lay"
            :market-id="market.event.id"
            :class="{
              'opacity-0': i !== 0 && twoOdds,
              'flex-grow-1': twoOdds
            }"
            :disabled="(i !== 0 && twoOdds) || !check(runner, 'lay', i, market)"
            @betData="
              $store.commit('placeBet/openPopover', {
                event,
                market,
                runner,
                allRunners: markets,
                oddsIndex: i,
                odds: {
                  price: getObjValue(runner.lay, i, ['price'], '-'),
                  index: i,
                  type: 'lay'
                },
                type: 'lay',
                bettingType:
                  market.bookMakerCustom && market.isJodiMarket
                    ? 'multiHorse'
                    : market.bookMakerCustom && !market.isJodiMarket
                    ? 'bookmaker'
                    : 'default'
              })
            "
          >
            <span
              v-if="market && check(runner, 'lay', i, market)"
              class="d-block text-center"
            >
              {{
                (market.id.includes('_SB')
                  ? (getObjValue(runner.lay, i, ['price'], '-') - 1) * 100
                  : getObjValue(runner.lay, i, ['price'], '-'))
                  | currencyFormat(2)
              }}

              <multiplyer
                v-if="
                  check(runner, 'lay', i, market) &&
                  getObjValue(runner.lay, i, ['size'], '-') &&
                  !market.id.includes('_SB')
                "
                :rates="getObjValue(runner.lay, i, ['size'], '-')"
                :multiplyer="multiplyer"
              ></multiplyer>
            </span>

            <span v-else class="d-block text-center">-</span>
          </btn-odds>
        </template>
      </v-card>

      <bet-popover
        v-if="
          $breakpoint.smAndDown &&
          betslipOpener(
            $auth,
            $store,
            runner.id,
            marketList?.[groupIndex(k)]?.id || market.id,
            event
          )
        "
        :key="`p-${k}`"
        :check-id="runner.id"
      ></bet-popover>
    </template>
    <template
      v-if="
        socketData.bookmakerMultiOdds === true &&
        bookmaker &&
        $auth.loggedIn &&
        !$breakpoint.xsOnly &&
        minmax.length
      "
    >
      <v-card class="d-flex align-center item-odds" dense flat tile height="45">
        <v-btn
          text
          tile
          color="white"
          class="text-capitalize text-left justify-start caption font-weight-bold flex-grow-1 flex-shrink-1"
        >
          <span class="black--text manage-overflow-two"> Max Bet </span>
        </v-btn>
        <template
          v-for="(i, key) in xsOnlyOdds($breakpoint.xsOnly, 'back', market)"
        >
          <div v-if="minmax && minmax[i].maxBet" :key="'back' + key">
            <v-btn
              class="btn-odds black--text font-weight-bold odds-width multiline-btn text-center didMutate px-1"
              style="
                font-size: 10px !important;
                letter-spacing: 0px;
                height: 40px;
                margin: 1px;
              "
              small
              tile
              depressed
            >
              <span class="d-block text-center">
                {{ minmax[i].maxBet }}
              </span>
            </v-btn>
          </div>
        </template>

        <template v-for="(i, key) in xsOnlyOdds($breakpoint.xsOnly)">
          <div v-if="minmax && minmax[i].maxBet" :key="'lay' + key">
            <v-btn
              class="btn-odds black--text font-weight-bold odds-width multiline-btn text-center didMutate px-1"
              style="
                font-size: 10px !important;
                letter-spacing: 0px;
                height: 40px;
                margin: 1px;
              "
              small
              tile
              depressed
            >
              <span class="d-block text-center">
                {{ minmax[i].maxBet }}
              </span>
            </v-btn>
          </div>
        </template>
      </v-card>
    </template>
    <template
      v-if="
        market &&
        market.bookMakerCustom &&
        socketData.marketInputText &&
        socketData.marketId === marketId
      "
    >
      <v-divider></v-divider>
      <v-toolbar flat class="primary--text caption" dense height="30"
        >{{ socketData.marketInputText }}
      </v-toolbar>
    </template>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import upperFirst from 'lodash/upperFirst'
// import merge from 'lodash/merge'
// import isString from 'lodash/isString'
import forEach from 'lodash/forEach'
import BtnOdds from '@/components/BtnOdds'
import OddsDisabled from '@/components/OddsDisabled'
import Multiplyer from '@/components/Multiplyer'
import BetPopover from '@/components/BetPopover'
import SimpleBar from '@/components/toolbars/SimpleBar'
// import socket from '~/plugins/socket.client'
export default {
  name: 'ItemsOdds',
  components: { BtnOdds, OddsDisabled, BetPopover, Multiplyer, SimpleBar },
  props: {
    market: { type: Object, default: () => {}, required: true },
    marketList: { type: Array, default: () => [], required: false },
    runners: { type: Array, default: () => [], required: true },
    twoOdds: { type: Boolean, default: false },
    matchoddsBookmaker: { type: Boolean, default: true },
    marketId: { type: [String, Number], default: 0, required: true },
    maxCommission: { type: Number, default: 0, required: false },
    bookmaker: { type: Boolean, default: false },
    bookmakerCommission: { type: Boolean, default: false },
    favoriteOdds: { type: Boolean, default: false },
    status: { type: String, default: '' },
    event: { type: Object, default: () => {}, required: false },
    showHeading: { type: Boolean, default: true, required: false }
  },
  data() {
    return {
      gameMode: 'SportsBook',
      markets: [],
      socketData: {},
      minmax: [],
      refresh: true
    }
  },
  computed: {
    ...mapState({
      books: (state) => state.betBooks.data,
      newBooks: (state) => state.betBooks.newData,
      matchIds: (state) => state.placeBet.matchIds,
      minMaxMarket: (state) => state.matchInside.minMaxMarket,
      balanceSettings: (state) => state.settings.balanceSettings
    }),
    multiplyer() {
      return this.balanceSettings?.settings[this.event?.eventTypeId]
        ?.volumeMultiplier
    }
  },
  watch: {
    runners() {
      this.markets = this.runners
    }
  },
  mounted() {
    this.socketData.bookmakerCommission = this.market.bookmakerCommission
    this.markets = this.runners
  },
  methods: {
    groupIndex(index) {
      return Math.floor(index / 2)
    },
    getBooks(books, id) {
      if (
        books &&
        Object.keys(books).filter((item) => item.includes(this.market.id)) &&
        Object.keys(books).filter((item) => item.includes(id))
      ) {
        return (
          books[`${this.market.id}-${id}`] &&
          books[`${this.market.id}-${id}`].pnl
        )
      } else {
        return 0
      }
    },
    async getMaxBet(markets) {
      let odds
      let bettingRunnerId
      let types
      forEach(markets, function (value) {
        if (!odds && !bettingRunnerId) {
          forEach(value.batb, function (batb) {
            if (batb && batb[2] && batb[2] > 0) {
              bettingRunnerId = value.betfairId
              odds = batb[2]
              types = 'back'
            }
          })
          forEach(value.batl, function (batl) {
            if (batl && batl[2] && batl[2] > 0) {
              bettingRunnerId = value.betfairId
              odds = batl[0]
              types = 'lay'
            }
          })
        }
      })
      if (odds && bettingRunnerId && this.$auth.loggedIn) {
        const minMaxData = {
          game: upperFirst(this.$route.params.category || 'Cricket'),
          loading: false,
          oddsSelected: odds,
          selectionId: bettingRunnerId,
          type: types,
          allmaxbets: true,
          marketId: this.marketId
        }
        await this.$store.dispatch('matchInside/getMinMaxMarket', minMaxData)
        if (
          !this.minMaxMarket.maxBet ||
          (this.minMaxMarket &&
            this.minMaxMarket.maxBet &&
            this.minMaxMarket.maxBet === 0)
        ) {
          this.minmax = []
        } else {
          this.minmax = [
            {
              maxBet: this.minMaxMarket.maxBet
            },
            {
              maxBet: this.minMaxMarket.maxBet1
            },
            {
              maxBet: this.minMaxMarket.maxBet2
            }
          ]
        }
      }
    },
    xsOnlyOdds(bool, type, bookmaker, runner) {
      if (bool) {
        if (
          !(bookmaker && bookmaker.name === 'BOOKMAKER') ||
          !(bookmaker && bookmaker.id.includes('_SB'))
        ) {
          if (runner?.back?.length === 1) {
            return [2]
          }
          if (runner?.back?.length === 2) {
            return [1]
          }
          if (runner?.back?.length === 3) {
            return [0]
          }
        }
        if (
          (bookmaker && bookmaker.name === 'BOOKMAKER') ||
          (bookmaker && bookmaker.id.includes('_SB'))
        ) {
          return [2]
        } else {
          return [0]
        }
      } else {
        if (type === 'back') {
          if (bookmaker && bookmaker.name === 'BOOKMAKER') {
            return [0, 1, 2]
          }
          if (bookmaker && bookmaker.name === 'Tied Match') {
            return [2, 1, 0]
          }
          if (bookmaker && bookmaker.id.includes('_SB')) {
            return [0, 1, 2]
          }
          if (runner?.back?.length === 1) {
            return [0, 1, 2]
          }
          if (runner?.back?.length === 2) {
            return [0, 2, 1]
          }
          if (runner?.back?.length === 3) {
            return [2, 1, 0]
          }
          // }
          return [2, 1, 0]
        }
        return [0, 1, 2]
      }
    },
    getObjValue(object, i, j, output, type = 'lay') {
      if (type === 'back') {
        if (object.length === 1) {
          return object && object.length && object?.[0]?.[j]
            ? object[0][j]
            : output
        } else if (object.length === 2) {
          return object && object.length && object?.[i - 1]?.[j]
            ? object[i - 1][j]
            : output
        } else {
          return object && object.length && object?.[i]?.[j]
            ? object[i][j]
            : output
        }
      }
      if (object.length === 1) {
        return object && object.length && object?.[0]?.[j]
          ? object[0][j]
          : output
      } else {
        return object && object.length && object?.[i]?.[j]
          ? object[i][j]
          : output
      }
    },
    check(runner, key, i, market) {
      // console.log('runner', runner)
      if (
        key === 'back' &&
        market &&
        market.eventType &&
        market.eventType.isMatchOdds
      ) {
        return true
      }
      let result = false
      if (market) {
        if (key !== 'lay') {
          i = 2 - i
        }
        result =
          runner && runner[key] && runner[key].length > 0 && runner[key][i]
      } else {
        result =
          runner &&
          runner[key] &&
          runner[key].length > 0 &&
          runner[key][i] &&
          runner[key][i].length > 0
      }
      return result
    },
    suspendedCheck(market) {
      if (market) {
        if (market?.status === 'SUSPENDED') {
          return 'SUSPENDED'
        }
      }
      if (market) {
        if (!market.isBettable) {
          return 'No Text'
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.opacity-0 {
  opacity: 0;
}
.v-btn {
  border-radius: 0.4rem;
}
.v-card:last-child {
  border-bottom-left-radius: 12px !important;
  border-bottom-right-radius: 12px !important;
}
</style>
